export default "__VITE_ASSET__BaeljX3n__"